module.exports = __webpack_public_path__ + "img/gzbgs.85fc9a46.jpg";